<div class="content-wrapper dashboard-box-mcpn p-b" *ngIf="!isLoading">

    <div class="col-md-12 myaccount-table ">



        <div class="container mt-2">
            <div class="container_hed"> Secure Payment</div>
            <div class="card_newtop">
                <div class="boxpadding">

                    <!-- <div [formGroup]="typeofPayment" *ngIf="typeofPayment" autocomplete="new-PaymentFormFlight">
                        <div class="mb-3 row">
                            <label for="inputPassword2" class="p-2">Payment Mode</label>
                            <select formControlName="paymentCurrencyOption" data-placeholder="Please select" class="form-control col-2" tabindex="2" (change)="selectViewMode('IN')">
                            <option *ngFor="let options of paymentCurrencyOptions" [value]="options.value">
                            {{ options.label }}
                            </option>
                            </select>
                            <div class="col-auto">
                                <div class="col-12 font12 alert alert-warning m-0 p-2 font600">
                                    <img alt="info" src="assets/images/freecancellation.svg" width="15px" /> We are accepting multiple payment currencies based on the locale. Please choose the desired currency from the Payment Mode.
                                </div>
                            </div>
                        </div>
                    </div> -->








                    <div class="borderbottomline_payment">
                        <div class="row">
                            <div class="col-lg-7 col-md-12">


                                <div>
                                    <!-- *ngIf="typeofPayment.controls['paymentCurrencyOption'].value && typeofPayment.controls['paymentCurrencyOption'].value=='US'" -->
                                    <div *ngIf="!getModeOfPayment()">
                                        <div class="paymentbox">
                                            <div class="makepaymentdiv">
                                                <div class="row">
                                                    <div class="col-lg-5 col-md-6 paymentheader paddingt5 mt-4">
                                                        Make Payment
                                                    </div>
                                                    <!-- <div class="col-lg-7 col-md-6 pr-lg-0">
                                                        <div class="securediv">
                                                            <div>
                                                                <span>Your Booking 100% Financially Protected</span>
                                                            </div>

                                                            <a (click)="commonservice.openDigicel()">
                                                                <img width="90" src="assets/images/northern-security.png" alt="ytbpayment" class="cursor" />
                                                            </a>
                                                            <a (click)="commonservice.openDigicel()">
                                                                <img src="assets/images/DigiCert-logo.png" alt="ytbpayment" class="digi-sec ml-1" />
                                                            </a>
                                                        </div>
                                                    </div> -->
                                                </div>
                                            </div>

                                            <form [formGroup]="typeofPayment" *ngIf="typeofPayment">
                                                <div *ngFor="let payment of paymentTypes; let i = index" class="custom-control custom-radio custom-control-inline">
                                                    <input formControlName="typeofpayment" (click)="setCheckBoxDisplayValues(payment)" type="radio" value="{{ payment.value }}" id="flightSearchRadio-{{ i }}" class="custom-control-input" />
                                                    <label class="custom-control-label" for="flightSearchRadio-{{ i }}">{{ payment.label }}</label>
                                                </div>
                                            </form>

                                            <div class="credit-card" *ngIf="creditcard">
                                                <form class="payment-form-wrapper" [formGroup]="paymentForm" *ngIf="paymentForm">
                                                    <div class="payment-desc paymenttabdatadiv">
                                                        <div class="card-form">
                                                            <div class="row marginb15">
                                                                <div class="col-lg-9 col-md-12">
                                                                    <div class="pull-right p_labels">
                                                                        We accept
                                                                        <img src="assets/images/image-regular/paymenticons.png" alt="acceptedcards" width="65%" />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row gap-20 mb-0">
                                                                <div class="col-12 col-sm-12 col-md-12">
                                                                    <div class="form-group">
                                                                        <label class="form-label">Name on card<span class="starclr">*</span></label>
                                                                        <input type="text" formControlName="nameOnCard" class="form-control" placeholder="Name on card" />

                                                                        <span class="err-msg" *ngIf="
                                        paymentForm.get('nameOnCard').touched &&
                                        paymentForm
                                          .get('nameOnCard')
                                          .hasError('required')
                                      " class="text text-danger">Cardholder name is required</span>


                                                                        <span class="err-msg" *ngIf="
                                      paymentForm.get('nameOnCard')
                                        .touched &&
                                        paymentForm.get('nameOnCard')
                                        .hasError('minlength') &&
                                        !paymentForm.get('nameOnCard')
                                          .hasError('required') &&
                                          !paymentForm.get('nameOnCard')
                                          .hasError('pattern') 
                                    " class="text text-danger">Please enter minimum 3 characters</span>


                                                                        <span class="err-msg" *ngIf="
                                    !paymentForm.get('nameOnCard')
                                      .hasError('required') &&
                                      paymentForm.get('nameOnCard')
                                      .hasError('pattern') 
                                  " class="text text-danger">Cardholder name should be in Format</span>



                                                                        <span class="err-msg" *ngIf="
                                  !paymentForm.get('nameOnCard')
                                    .hasError('required') &&
                                    paymentForm.get('nameOnCard').hasError('space')
                                " class="text text-danger">
                                            Only one space allows between the letters
                                          </span>






                                                                    </div>
                                                                </div>

                                                                <div class="col-12 col-sm-12 carcolwidth">
                                                                    <div class="form-group">
                                                                        <div class="d-flex">
                                                                            <label class="form-label">Card number<span class="starclr">*</span></label>


                                                                            <input (keyup)="validateCardData($event)" type="text" class="form-control form-bg-light pr-0" placeholder="xxxx-xxxx-xxxx-xxxx" size="18" NumbersOnly formControlName="cardNumber" onPaste="return false" onCopy="return false" maxlength="19" />

                                                                            <span class="flightcardtype" *ngIf="cardImage"><img [src]="cardImage" alt="image"
                                          width="40" /></span>
                                                                        </div>


                                                                        <span class="err-msg" *ngIf="
                                            paymentForm.get('cardNumber')
                                              .touched &&
                                              paymentForm.get('cardNumber')
                                              .hasError('cardnumber') && 
                                              !paymentForm.get('cardNumber')
                                              .hasError('pattern')
                                          " class="text text-danger">
                                              Please enter minimum 13 digits
                                            </span>


                                                                        <span class="err-msg" *ngIf="
                                        paymentForm.get('cardNumber').touched &&
                                        paymentForm
                                          .get('cardNumber')
                                          .hasError('required')
                                      " class="text text-danger">Card number is required</span>


                                                                        <span class="err-msg" *ngIf="
                                      !paymentForm.get('cardNumber')
                                      .hasError('required') &&
                                        paymentForm.get('cardNumber')
                                        .hasError('pattern')
                                        && !paymentForm.get('cardNumber')
                                        .hasError('cardnumber')
                                    " class="text text-danger">Card number should be in format</span>











                                                                    </div>
                                                                </div>

                                                                <div class="col-12 col-sm-12 col-md-12">
                                                                    <div class="row">
                                                                        <div class="col-4 col-sm-4">
                                                                            <div class="form-group">
                                                                                <label class="form-label">Expiry Month<span class="starclr">*</span></label>
                                                                                <select formControlName="expiresIn" data-placeholder="Please select" class="form-control" tabindex="2">
                                          <option  value="" selected>  Select Month  </option>
                                          <option *ngFor="let month of monthArray" [value]="month">
        
                                            
                                            {{ month }}
                                          </option>
                                        </select>
                                                                                <span class="select-arrow"></span>
                                                                                <span class="err-msg" *ngIf="
                                            paymentForm.get('expiresIn').touched &&
                                            paymentForm
                                              .get('expiresIn')
                                              .hasError('required')
                                          " class="text text-danger">Expiry month is required</span>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-4 col-sm-4">
                                                                            <div class="form-group">
                                                                                <label class="form-label">Expiry Year<span class="starclr">*</span></label>
                                                                                <select formControlName="expiryYear" data-placeholder="Please select" class="form-control" tabindex="2">
                                          <option  value="" selected> Select Year </option>
                                          <option *ngFor="let year of yearArray" [value]="year">
                                            {{ year }}
                                          </option>
                                        </select>
                                                                                <span class="select-arrow"></span>
                                                                                <span class="err-msg" *ngIf="
                                            paymentForm.get('expiryYear').touched &&
                                            paymentForm
                                              .get('expiryYear')
                                              .hasError('required')
                                          " class="text text-danger">Expiry year is required</span>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-4 col-sm-3">
                                                                            <div class="form-group">
                                                                                <label class="form-label">CVV<span class="starclr">*</span></label>
                                                                                <input type="password" NumbersOnly [maxlength]="cvvLength" formControlName="cvv" class="form-control" placeholder="xxx" />




                                                                                <span class="err-msg" *ngIf="
                                                                                paymentForm.get('cvv')
                                                                                  .touched &&
                                                                                  paymentForm.get('cvv')
                                                                                  .hasError('minlength') &&
                                                                                  !paymentForm.get('cvv')
                                                                                    .hasError('required')
                                                                              " class="text text-danger">
                                                                                    Please enter minimum 3 digits
                                                                                  </span>

                                                                                <span class="err-msg" *ngIf="
                                                                                  paymentForm.get('cvv')
                                                                                    .touched &&
                                                                                    paymentForm.get('cvv')
                                                                                    .hasError('required')
                                                                                " class="text text-danger">cvv is required</span>


                                                                                <span class="err-msg" *ngIf="
                                                                              paymentForm.get('cvv')
                                                                              .hasError('pattern') &&
                                                                              !paymentForm.get('cvv')
                                                                                .hasError('minlength') &&
                                                                                !paymentForm.get('cvv')
                                                                          " class="text text-danger">CVV Should be in Format</span>







                                                                            </div>
                                                                        </div>
                                                                        <div class="col-1 col-sm-1 col-md-1">
                                                                            <div class="flightcvv">
                                                                                <i class="fas fa-info-circle text-info" data-toggle="tooltip" ata-placement="top" title="Card Back side 3 Digits"></i>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>



                                            <div class="payment-option-item paypal" *ngIf="paypal">
                                                <div class="custom-control custom-radio">
                                                    <div class="payment-desc">
                                                        <p>
                                                            Paypal will convert your currency into his Own currency. No Extra charges apply
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <!-- *ngIf="typeofPayment.controls['paymentCurrencyOption'].value && typeofPayment.controls['paymentCurrencyOption'].value=='IN'" -->
                                    <!-- <div *ngIf="getModeOfPayment()">
                                        <div class="paymentbox">
                                            <p>Make a Payment through Razor Pay</p>
                                        </div>
                                    </div> -->
                                </div>


                                <!-- Address Start Here  -->


                                <div class="paymentbox mt-4">
                                    <div class="paymentheader">Billing Address
                                    </div>
                                    <form [formGroup]="BillingForm">
                                        <div class="row gap-20 mb-0 paymenttabdatadiv">
                                            <div class="col-12 col-sm-12">
                                                <div class="form-group">
                                                    <label class="form-label">Address Line 1 <span class="starclr"  >*</span></label>
                                                    <input formControlName="address1" SpecialChars type="text" class="form-control" />

                                                    <span>
                                                 
                                                 
                                                    <span class="err-msg" *ngIf="
                                  BillingForm.get('address1').touched &&
                                  BillingForm.get('address1').hasError('required')
                                " class="text text-danger">Address is required</span>


                                                    </span>


                                                    <span class="err-msg" *ngIf="
                                                    !BillingForm.get('address1')
                                                      .hasError('required') &&
                                                      BillingForm.get('address1').hasError('space')
                                                  " class="text text-danger">
                                                        Only one space allows between the letters
                                                      </span>
                                                    <span class="err-msg" *ngIf="
                                                        BillingForm.get('address1')
                                                          .touched &&
                                                          BillingForm.get('address1')
                                                          .hasError('pattern') &&
                                                          !BillingForm.get('address1')
                                                            .hasError('required')
                                                      " class="text text-danger">Address is not in format</span>




                                                </div>
                                            </div>

                                            <div class="col-12 col-sm-6">
                                                <div class="form-group">
                                                    <label class="form-label">Address Line 2</label>
                                                    <input formControlName="address2" SpecialChars type="text" class="form-control" />



                                                    <span>
                                                        <span class="err-msg" *ngIf="
                                                                      BillingForm.get('address2')
                                                                        .touched &&
                                                                        BillingForm.get('address2')
                                                                        .hasError('pattern')
                                                                    " class="text text-danger">Address is not in
                                format</span>



                                                    <span class="err-msg" *ngIf="
                            !BillingForm.get('address2')
                              .hasError('required') &&
                              BillingForm.get('address2').hasError('space')
                          " class="text text-danger">
                                Only one space allows between the letters
                              </span>
                                                    </span>




                                                </div>
                                            </div>

                                            <div class="col-12 col-sm-6">
                                                <div class="form-group">
                                                    <label class="form-label">Address Line 3 : (Street/Road/Lane)</label>
                                                    <input formControlName="address3" SpecialChars type="text" class="form-control" />


                                                    <span>
                                                        <span class="err-msg" *ngIf="
                                                                      BillingForm.get('address3')
                                                                        .touched &&
                                                                        BillingForm.get('address3')
                                                                        .hasError('pattern')
                                                                    " class="text text-danger">Address is not in
                                format</span>



                                                    <span class="err-msg" *ngIf="
                            !BillingForm.get('address3')
                              .hasError('required') &&
                              BillingForm.get('address3').hasError('space')
                          " class="text text-danger">
                                Only one space allows between the letters
                              </span>
                                                    </span>



                                                </div>
                                            </div>

                                            <div class="col-12 col-sm-6">
                                                <div class="form-group">
                                                    <label class="form-label">Country <span class="starclr"  >*</span></label>
                                                    <select (change)="getStates($event, 'billing')" formControlName="country" data-placeholder="Country" class="form-control" tabindex="2">
                                <option value="" selected> Select Country </option>
                                <option value="{{ country.countryISO2 }}" *ngFor="let country of allCountryList">
                                  {{ country.countryName }}
                                </option>
                              </select>
                                                    <span class="select-arrow"></span>
                                                    <span>
                                                
                                                    <span class="err-msg" *ngIf="
                                  BillingForm.get('country').touched &&
                                  BillingForm.get('country').hasError('required')
                                " class="text text-danger">Country is required</span>
                                                    </span>

                                                </div>
                                            </div>

                                            <div class="col-12 col-sm-6">
                                                <div class="form-group">
                                                    <label class="form-label">State

                                                        <ng-container *ngIf="validator('billing')"> <span class="starclr">* </span>  </ng-container>
                                                    </label>
                                                    <select formControlName="state" data-placeholder="State" class="form-control" tabindex="2">
                                <option value="" selected> Select State </option>
                                <option value="{{ state.state_Code }}" *ngFor="let state of stateResponseForPersonalAddress">
                                  {{ state.state_Name }}
                                </option>
                              </select>
                                                    <span class="select-arrow"></span>

                                                    <span>
                                                        <span class="err-msg" *ngIf="
                              BillingForm.get('state')
                                .touched &&
                             BillingForm.get('state')
                                .hasError('required')
                            " class="text text-danger">State is required</span>
                                                    </span>

                                                </div>
                                            </div>

                                            <div class="col-12 col-sm-6">
                                                <div class="form-group">
                                                    <label class="form-label">City <span class="starclr"  >*</span></label>
                                                    <input formControlName="city" type="text" class="form-control" />


                                                    <span>
                                                        <span class="err-msg" *ngIf="
                                  BillingForm.get('city').touched &&
                                  BillingForm.get('city')
                                    .hasError('required')
                                " class="text text-danger">City is required</span>

                                                    <span class="err-msg" *ngIf="
                                BillingForm.get('city').touched &&
                                BillingForm.get('city')
                                  .hasError('pattern') &&
                                  !BillingForm.get('city')
                                    .hasError('required')
                              " class="text text-danger">City is not in format</span>
                                                    <span class="err-msg" *ngIf="
                            !BillingForm.get('city')
                              .hasError('required') &&
                              BillingForm.get('city').hasError('space')
                          " class="text text-danger">
                                Only one space allows between the letters
                              </span>
                                                    </span>




                                                </div>
                                            </div>

                                            <div class="col-12 col-sm-6">
                                                <div>
                                                    <div class="row">
                                                        <div class="col-sm-6 flightwidth1">
                                                            <div class="form-group">
                                                                <label class="form-label">Zip code <span class="starclr"  >*</span></label>
                                                                <input formControlName="zip" type="text" class="form-control" onkeypress="return ((event.keyCode > 64 && event.keyCode < 91) || (event.keyCode > 96 && event.keyCode < 123) || event.keyCode == 8 || event.keyCode == 32 || (event.keyCode >= 48 && event.keyCode <= 57));"
                                                                />



                                                                <span>
        
        
                                                                    <span class="err-msg" *ngIf="
                                BillingForm.get('zip')
                                  .touched &&
                                  BillingForm.get('zip')
                                  .hasError('pattern') &&
                                  !paymentForm
                                    .get('billingaddress.zipcode')
                                    .hasError('required')
                              " class="text text-danger">Zipcode is not in format</span>






                                                                <span class="err-msg" *ngIf="
                                        BillingForm.get('zip')
                                          .touched &&
                                          BillingForm.get('zip')
                                          .hasError('required')
                                      " class="text text-danger">Zip code is required</span>

                                                                </span>
                                                            </div>
                                                        </div>

                                                        <span class="zipcode">-</span>
                                                        <div class="col-sm-5 flightwidth2">
                                                            <input formControlName="zip1" type="text" style="width: 130%" class="form-control" />



                                                            <span class="err-msg" *ngIf="
                                                            BillingForm.get('zip1')
                                                              .touched &&
                                                              BillingForm.get('zip1')
                                                              .hasError('pattern')
                                                          " class="text text-danger">Zipcode1 is not in format</span>


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                    <div class="ml-4">
                                        <div class="payment-option-box customradiodiv">
                                            <div class="payment-option-item">
                                                <form class="payment-form-wrapper ml-20" [formGroup]="typeofPayment">
                                                    <div *ngFor="let addr of addressTypes; let i = index" class="mb-15">
                                                        <input formControlName="billingaddress" (click)="setAddressCheckBoxDisplayValues(addr)" type="radio" value="{{ addr.value }}" id="address-{{ i }}" class="custom-control-input" />
                                                        <label class="custom-control-label" for="address-{{ i }}">{{ addr.label }}</label>
                                                    </div>
                                                </form>
                                            </div>

                                            <form [formGroup]="PersonalForm">
                                                <div class="payment-option-item" *ngIf="sameaddr">
                                                    <div class="custom-control pb-10">
                                                        <div class="paymenttabdatadiv">
                                                            <div class="paymentheader">Personal Address</div>

                                                            <p class="post-heading"></p>
                                                            <div class="row gap-20 mb-0 ">
                                                                <div class="col-12 col-sm-12">
                                                                    <div class="form-group">
                                                                        <label class="form-label">Address Line 1<span class="starclr"  >*</span></label>
                                                                        <input formControlName="address1" SpecialChars type="text" class="form-control" />

                                                                        <span>
                                                 
                                                 
                                                    <span class="err-msg" *ngIf="
                                  PersonalForm.get('address1').touched &&
                                  PersonalForm.get('address1').hasError('required')
                                " class="text text-danger">Address is required</span>


                                                                        </span>


                                                                        <span class="err-msg" *ngIf="
                                                    !PersonalForm.get('address1')
                                                      .hasError('required') &&
                                                      PersonalForm.get('address1').hasError('space')
                                                  " class="text text-danger">
                                                        Only one space allows between the letters
                                                      </span>
                                                                        <span class="err-msg" *ngIf="
                                                        PersonalForm.get('address1')
                                                          .touched &&
                                                          PersonalForm.get('address1')
                                                          .hasError('pattern') &&
                                                          !PersonalForm.get('address1')
                                                            .hasError('required')
                                                      " class="text text-danger">Address is not in format</span>

                                                                    </div>
                                                                </div>

                                                                <div class="col-12 col-sm-6">
                                                                    <div class="form-group">
                                                                        <label class="form-label">Address Line 2
                                        </label>
                                                                        <input formControlName="address2" SpecialChars type="text" class="form-control" />


                                                                        <span>
                                                                            <span class="err-msg" *ngIf="
                                                                                          PersonalForm.get('address2')
                                                                                            .touched &&
                                                                                            PersonalForm.get('address2')
                                                                                            .hasError('pattern')
                                                                                        " class="text text-danger">Address is not in
                                                    format</span>



                                                                        <span class="err-msg" *ngIf="
                                                !PersonalForm.get('address2')
                                                  .hasError('required') &&
                                                  PersonalForm.get('address2').hasError('space')
                                              " class="text text-danger">
                                                    Only one space allows between the letters
                                                  </span>
                                                                        </span>


                                                                    </div>
                                                                </div>
                                                                <div class="col-12 col-sm-6">
                                                                    <div class="form-group">
                                                                        <label class="form-label">Address Line 3</label>
                                                                        <input formControlName="address3" SpecialChars type="text" class="form-control" />




                                                                        <span>
                                                                            <span class="err-msg" *ngIf="
                                                                                          PersonalForm.get('address3')
                                                                                            .touched &&
                                                                                            PersonalForm.get('address3')
                                                                                            .hasError('pattern')
                                                                                        " class="text text-danger">Address is not in
                                                    format</span>



                                                                        <span class="err-msg" *ngIf="
                                                !PersonalForm.get('address3')
                                                  .hasError('required') &&
                                                  PersonalForm.get('address3').hasError('space')
                                              " class="text text-danger">
                                                    Only one space allows between the letters
                                                  </span>
                                                                        </span>


                                                                    </div>
                                                                </div>

                                                                <div class="col-12 col-sm-6">
                                                                    <div class="form-group chosen-bg-light">
                                                                        <label class="form-label">Country <span class="starclr"  >*</span></label>
                                                                        <select formControlName="country" data-placeholder="Country" class="form-control" tabindex="2" (change)="getStates($event, 'personal')">
                                                                            <option value="" selected >Select Country
                                                                            </option>
                                                                            <option value="{{ country.countryISO2 }}" *ngFor="let country of allCountryList">
                                            {{ country.countryName }}
                                          </option>
                                        </select>
                                                                        <span class="select-arrow"></span>
                                                                        <span>
        
                                                                        <span class="err-msg" *ngIf="
                                            PersonalForm.get('country').touched &&
                                            PersonalForm.get('country').hasError(
                                              'required'
                                            )
                                          " class="text text-danger">Country is required</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-12 col-sm-6">
                                                                    <div class="form-group">
                                                                        <label class="form-label">State 
                                                                            
                                                                            <ng-container *ngIf="validator('personal')"> <span class="starclr">* </span>  </ng-container>

                                                                        </label>
                                                                        <select formControlName="state" data-placeholder="State" class="chosen-the-basic form-control" tabindex="2">
                                                                            <option  value="" selected>Select State
                                                                            </option>
                                          <option value="{{ state.state_Code }}" *ngFor="let state of stateResponseForPersonalAddress">
                                            {{ state.state_Name }}
                                          </option>
                                        </select>
                                                                        <span class="select-arrow"></span>

                                                                        <span>
                                                                            <span class="err-msg" *ngIf="
                                                  PersonalForm.get('state')
                                                    .touched &&
                                                 PersonalForm.get('state')
                                                    .hasError('required')
                                                " class="text text-danger">State is required</span>
                                                                        </span>


                                                                    </div>
                                                                </div>
                                                                <div class="col-12 col-sm-6">
                                                                    <div class="form-group">
                                                                        <label class="form-label">City <span class="starclr"  >*</span></label>
                                                                        <input formControlName="city" type="text" class="form-control" />



                                                                        <span>
                                                                            <span class="err-msg" *ngIf="
                                                      PersonalForm.get('city').touched &&
                                                      PersonalForm.get('city')
                                                        .hasError('required')
                                                    " class="text text-danger">City is required</span>

                                                                        <span class="err-msg" *ngIf="
                                                    PersonalForm.get('city').touched &&
                                                    PersonalForm.get('city')
                                                      .hasError('pattern') &&
                                                      !PersonalForm.get('city')
                                                        .hasError('required')
                                                  " class="text text-danger">City is not in format</span>
                                                                        <span class="err-msg" *ngIf="
                                                !PersonalForm.get('city')
                                                  .hasError('required') &&
                                                  PersonalForm.get('city').hasError('space')
                                              " class="text text-danger">
                                                    Only one space allows between the letters
                                                  </span>
                                                                        </span>
                                                                    </div>
                                                                </div>


                                                                <div class="col-12 col-sm-6">
                                                                    <div class="row">
                                                                        <div class="col-sm-6 flightwidth1">
                                                                            <div class="form-group">
                                                                                <label class="form-label">Zip code
                                              <span class="starclr"  >*</span></label>
                                                                                <input formControlName="zip" type="text" class="form-control" onkeypress="return ((event.keyCode > 64 && event.keyCode < 91) || (event.keyCode > 96 && event.keyCode < 123) || event.keyCode == 8 || event.keyCode == 32 || (event.keyCode >= 48 && event.keyCode <= 57));"
                                                                                />


                                                                                <span>
        
        
                                                                    <span class="err-msg" *ngIf="
                                PersonalForm.get('zip')
                                  .touched &&
                                  PersonalForm.get('zip')
                                  .hasError('pattern') &&
                                  !paymentForm
                                    .get('billingaddress.zipcode')
                                    .hasError('required')
                              " class="text text-danger">Zipcode is not in format</span>






                                                                                <span class="err-msg" *ngIf="
                                        PersonalForm.get('zip')
                                          .touched &&
                                          PersonalForm.get('zip')
                                          .hasError('required')
                                      " class="text text-danger">Zip code is required</span>

                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <span class="zipcode">-</span>
                                                                        <div class="col-sm-6 flightwidth2">
                                                                            <input formControlName="zip1" type="text" class="form-control" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>


                                <!-- Address End Here -->



                            </div>
                            <div class="col-lg-5 col-md-12">

                                <div class="">
                                    <div class="mt-3 col-md-12 paymentbox">
                                        <div class="paymentheader">Payment Summary</div>
                                       
                                        
                                        <div class="row">
                                            <ng-container *ngIf="bookingdata?.bookingType"> 

                                            <div class="pay-5 paymentcol2 pl-15">Booking Type</div>
                                            <div class="pay-5 pr-15  paymentcol2 p_amountdiv">
                                               
                                                    {{ bookingdata?.bookingType }} 
                                                
                                            </div>
                                            </ng-container>
                                            <ng-container *ngIf="bookingdata?.comments"> 
                                            <div class="pay-5 paymentcol2 pl-15">Comments</div>
                                            <div class="pay-5 pr-15  paymentcol2 p_amountdiv">
                                               
                                                
                                                    {{ bookingdata?.comments }} 
                                                
                                            </div>
                                        </ng-container>


                                            <div class="pay-5 paymentcol2 pl-15">Total Payment</div>
                                            <div class="pay-5 pr-15  paymentcol2 p_amountdiv">
                                                {{ modeCurrency }}
                                                <span >
                                                    {{ convertToFloat(bookingdata?.paymentGatewayDisplayAmount) }} <img alt="info" src="assets/images/freecancellation.svg"
                                                        width="15px"
                                                        title="Approximate Charged Amount from Your Account" />
                                                </span>
                                            </div>
                                        </div>


                                    </div>


                                    <div class="mt-3 col-md-12 paymentbox">
                                        <div class="pb-3">
                                            <h5>
                                                <i class="fas fa-thumbs-up thumps"></i>
                                                <span class="ml-2">Lowest Price
                                                    <strong class="text-warning">Guarantee</strong></span>
                                            </h5>
                                        </div>
                                        <div class="text-justify">
                                            <span><strong>Please Note: </strong>Experience peace of mind with our commitment to offering the best prices. Should you find a lower rate for the same flight on another platform, let us know, and we’ll match it, guaranteeing you the most affordable travel options. Our dedication to transparency means no hidden fees, giving you a clear and straightforward booking experience. T&C applied.
                                            </span>
                                        </div>
                                    </div>

                                    <div class="col-md-12 mt-10 paymentbox">
                                        <div class="securediv pb-3">
                                            <div class="mb-1">
                                                <span>Your Booking 100% Financially Protected</span>
                                            </div>
                                            <a  class="cur_pointer">
                                                <img width="90" src="assets/images/northern-security.png" alt="ytbpayment" class="cursor" />
                                            </a>
                                            <a  class="cur_pointer">
                                                <img src="assets/images/DigiCert-logo.png" alt="ytbpayment" class="digi-sec ml-1" />
                                            </a>
                                        </div>

                                        <div class="text-justify">
                                            <span>Experience the utmost security when booking with us. Our secure SSL booking guarantees the safety of your sensitive data during the booking process. Rest easy knowing that your information is encrypted to the highest industry standards. Our commitment to cybersecurity includes advanced security measures ensuring your online transactions are always safeguarded.
                                            </span>
                                        </div>


                                    </div>
                                </div>

                                <!-- <div class="txt mt-2">
                                    <a type="button" data-toggle="modal" data-target="#exampleModal">
                                        <img src="assets/images/amenities-check.png" class="mr-1" alt="Image" /> Cancellation Policy
                                    </a>
                                </div>
                                <div class="subboxsection_totaltop">
                                    <div class="row" *ngIf="modeCurrency===currentCurrency">
                                        <div class="pay-5 paymentcol2 pl-15">Total</div>
                                        <div class="pay-5 pr-15 text-right paymentcol2 text-success font600">
                                            {{ currentCurrency }}
                                            <span>
                              {{ convertToFloat(bookingdata?.paymentGatewayDisplayAmount) }}
                            </span>
                                        </div>
                                    </div>



                                    <div class="row" *ngIf="modeCurrency!=currentCurrency">
                                        <div class="pay-5 paymentcol2 pl-15">Total </div>
                                        <div class="pay-5 pr-15 text-right paymentcol2 p_amountdiv">
                                            {{ modeCurrency }}
                                            <span>
                    {{
                        convertToFloat(bookingdata?.paymentGatewayDisplayAmount)
                    }}   </span>
                                        </div>
                                    </div>


                                </div> -->








                            </div>
                        </div>
                    </div>
                    <div class="mb-20"></div>
                    <div class="mb-20"></div>
                    <div class="custom-control custom-checkbox cursor">
                        <p-checkbox value="checked" [(ngModel)]="termsandcondi"> </p-checkbox>

                        <label class="" for="acceptTerm">&nbsp; I Agreed &nbsp;</label><a (click)="navigateToTermsAndConditions()" class="customlinks">
                    Terms and Conditions</a>, and <a class="customlinks" (click)="navigateToPrivacyPolicy()">Privacy Policy </a>

                        <div class="invalid-feedback">
                            <div *ngIf="termsandconditons">
                                <b>Terms and conditions required</b>
                            </div>
                        </div>
                    </div>

                    <div class="row paymenttabdatadiv mt-10 ml-0">
                        <div class="col-12 col-sm-12">
                            <div class="form-group">
                                <label class="form-label">Terms and Conditions </label>
                                <div class="form-control form-controltextarea">
                                    <textarea class="form-controlcustom">
                                              General Principles
        This privacy policy sets out how Yourtravelbooking use and protect any information that you give when you use this website.
        
        Yourtravelbooking is committed to ensuring that your privacy is protected. Should we ask you to provide certain information by which you can be identified when using this website, then you can be assured that it will only be used in accordance with this privacy statement.
        
        Yourtravelbooking may change this policy from time to time by updating this page. You should check this page from time to time to ensure that you are happy with any changes. This policy is effective as of March 2017.
        
        What we collect
        We may collect the following information
        
        • name and job title
        • contact information including email address
        • demographic information such as postcode, preferences and interests
        • other information relevant to customer surveys and/or offers
                                          </textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12 text-center">
                            <a (click)="proceedToActivityBooking()" class="btn savenext_but padding30">Pay & Book Now
                    </a>
                        </div>
                    </div>
                </div>
















            </div>
        </div>
    </div>

    <div class="ml-4 text-center"><a class="pl-2 viewdetails" routerLink="/"> Click Here Go Home </a></div>
</div>


<div class="modal fade show" id="loader-3" style="display: block" *ngIf="isLoading">
    <div class="modal-dialog" style="min-width: 35% !important; width: 0; margin-top: 12%">
        <div class="modal-content">
            <div class="modal-body">
                <div class="col-md-12 text-center pb-20 pt-20">
                    <img src="assets/images/image-regular/Double.gif" alt="Image" width="110px" />
                    <p class="mt-20 opensans font20 font600">Please wait..</p>
                </div>
            </div>
        </div>
    </div>
</div>